import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BrowserModule, HammerModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MenuComponent } from './menu/menu.component';
import { AllObjectsDemo } from './pages/all-objects/all-objects.component';
import { CameraTools } from './pages/camera-tools/camera-tools.component';
import { ClippingPlanesDemo } from './pages/clipping-planes/clipping-planes.component';
import { CompositeMaterialsDemo } from './pages/composite-materials/composite-materials.component';
import { CustomShadersDemo } from './pages/custom-shaders/custom-shaders.component';
import { DefaultPageComponent } from './pages/default-page/default-page.component';
import { DemoWith500000ItemsComponent } from './pages/demo-with-500000-items/demo-with-500000-items.component';
import { IndexedMeshObject } from './pages/indexed-mesh-object/indexed-mesh-object.component';
import { LayerPositionDemo } from './pages/layer-position/layer-position.component';
import { LayersDemo } from './pages/layers/layers.component';
import { LightsDemo } from './pages/lights/lights.component';
import { LinesDemo } from './pages/lines/lines.component';
import { PointsDemo } from './pages/points/points.component';
import { RaycastDemo } from './pages/raycast/raycast.component';
import { ArtifactPickerComponent } from './pages/hyperscene-advanced/components/artifact-picker/artifact-picker.component';
import { ViewerViewpointsPanelComponent } from './pages/hyperscene-advanced/components/viewer-viewpoints-panel/viewer-viewpoints-panel.component';
import { ViewerQualityPanelComponent } from './pages/hyperscene-advanced/components/viewer-quality-panel/viewer-quality-panel.component';
import { ViewerSettingsPanelComponent } from './pages/hyperscene-advanced/components/viewer-settings-panel/viewer-settings-panel.component';
import { ViewerLoadingOverlayComponent } from './pages/hyperscene-advanced/components/viewer-loading-overlay/viewer-loading-overlay.component';
import { ViewerToolsPanelComponent } from './pages/hyperscene-advanced/components/viewer-tools-panel/viewer-tools-panel.component';
import { ViewerToolbarComponent } from './pages/hyperscene-advanced/components/viewer-toolbar/viewer-toolbar.component';
import { ViewerSceneTreePanelComponent } from './pages/hyperscene-advanced/components/viewer-scene-tree-panel/viewer-scene-tree-panel.component';
import { ViewerStatsPanelComponent } from './pages/hyperscene-advanced/components/viewer-stats-panel/viewer-stats-panel.component';
import { HypersceneAdvancedDemo } from './pages/hyperscene-advanced/hyperscene-advanced.component';
import { HypersceneArtifactsDemo } from './pages/hyperscene-artifacts/hyperscene-artifacts.component';
import { HypersceneNewDemo } from './pages/hyperscene-new/hyperscene-new.component';
import { HypersceneViewerDemo } from './pages/hyperscene-viewer/hyperscene-viewer.component';
import { SdkViewerDemo } from './pages/sdk-viewer/sdk-viewer.component';
import { IfcMergeToolsComponent } from './pages/merge-tools/merge-tools.component';
import { SpritesDemo } from './pages/sprites/sprites.component';
import { StandardGeometricObjects } from './pages/standard-geometric-objects/standard-geometric-objects.component';
import { TexturedGeometricObjects } from './pages/textured-geometric-objects/textured-geometric-objects.component';
import { UiToolsDemo } from './pages/ui-tools/ui-tools.component';
import { UserActionsComponent } from './pages/user-actions/user-actions.component';
import { UniqueObjectsDemo } from './pages/unique-objects/unique-objects.component';
import { ViewerHelpComponent } from './pages/viewer-help/viewer-help.component';

@NgModule({
  declarations: [
    AppComponent,
    DefaultPageComponent,
    MenuComponent,
    DemoWith500000ItemsComponent,
    UserActionsComponent,
    CameraTools,
    IndexedMeshObject,
    StandardGeometricObjects,
    LightsDemo,
    TexturedGeometricObjects,
    LinesDemo,
    PointsDemo,
    AllObjectsDemo,
    LayersDemo,
    SpritesDemo,
    RaycastDemo,
    CustomShadersDemo,
    UiToolsDemo,
    ClippingPlanesDemo,
    LayerPositionDemo,
    HypersceneAdvancedDemo,
    HypersceneArtifactsDemo,
    ArtifactPickerComponent,
    ViewerViewpointsPanelComponent,
    ViewerQualityPanelComponent,
    ViewerSettingsPanelComponent,
    ViewerLoadingOverlayComponent,
    ViewerToolsPanelComponent,
    ViewerToolbarComponent,
    ViewerSceneTreePanelComponent,
    ViewerStatsPanelComponent,
    HypersceneNewDemo,
    HypersceneViewerDemo,
    SdkViewerDemo,
    IfcMergeToolsComponent,
    CompositeMaterialsDemo,
    UniqueObjectsDemo,
    ViewerHelpComponent,
  ],
  imports: [CommonModule, BrowserModule, AppRoutingModule, HammerModule],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule {}
